import { Typography } from '@mui/material'
import React, { memo } from 'react'
import tw from 'twin.macro'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import EmptySearchImage from 'src/assets/images/empty-search.svg'
import { colors } from 'src/theme'

interface Props {
  hasActiveFilters: boolean
}

/**
 * Filtered-to-nothing and genuinely-empty are different problems for the customer: one is fixed by clearing a
 * filter, the other by sharing the link. The grid uses the same slot for both, so the copy is chosen here.
 */
const EmptyCandidatesComponent = ({ hasActiveFilters }: Props) => {
  return (
    <div css={tw`flex flex-1 h-full justify-center items-center flex-col py-8`}>
      {/* Decorative: the heading below already carries the meaning, so screen readers skip the art. */}
      <img src={hasActiveFilters ? EmptySearchImage : EmptyImage} alt="" />
      <Typography css={tw`mb-1 mt-2`} variant="h4" fontWeight={600}>
        {hasActiveFilters ? 'No candidates match these filters' : 'Nothing here yet'}
      </Typography>
      <Typography color={colors.SHADES_GREY_400} variant="body2">
        {hasActiveFilters
          ? 'Try a different market, vehicle type or opportunity, or clear the search.'
          : 'Share an opportunity link where you advertise and applications will land here.'}
      </Typography>
    </div>
  )
}

export const EmptyCandidates = memo(EmptyCandidatesComponent)
